import type { Card } from 'types';

const LEGACY_CACHE_KEY = 'blinq:last-onboarding-card';
const CACHE_KEY_PREFIX = 'blinq:onboarding-card:';

type CachedCard = Pick<Card, 'color' | 'layout'>;

function getCacheKey(ownerId: string) {
  return `${CACHE_KEY_PREFIX}${ownerId}`;
}

function removeLegacyCache() {
  window.localStorage.removeItem(LEGACY_CACHE_KEY);
}

export function readCachedOnboardingCard(ownerId: string): Partial<CachedCard> | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }
  try {
    removeLegacyCache();
    const raw = window.localStorage.getItem(getCacheKey(ownerId));
    if (!raw) {
      return undefined;
    }
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? (parsed as Partial<CachedCard>) : undefined;
  } catch {
    return undefined;
  }
}

export function writeCachedOnboardingCard(ownerId: string, card: Card): void {
  if (typeof window === 'undefined') {
    return;
  }
  const slim: Partial<CachedCard> = {
    color: card.color,
    layout: card.layout,
  };
  try {
    removeLegacyCache();
    window.localStorage.setItem(getCacheKey(ownerId), JSON.stringify(slim));
  } catch {
    // ignore quota errors
  }
}
